/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { API_PATH } from "src/environments/config";

@Injectable({
  providedIn: "root",
})
export class GetVideoCallDataService {
  public fromAppointments;
  constructor(private http: HttpClient, private router: Router) {}

  getVideoCallData(
    code: string,
    type?: string,
    spot?: boolean,
    email?,
    orderlink?,
    mobile?
  ) {
    let finalParams = new HttpParams();
    if (spot) {
      finalParams = finalParams
        .set("code", code)
        .set("type", type)
        .set("OTP", "")
        .set("spot", "true");
      // finalParams = { code, type, OTP: "", spot: "true" };
      if (mobile) {
        finalParams = finalParams.set("mobile", mobile);
        // finalParams["mobile"] = mobile;
      }
      if (email) {
        finalParams = finalParams.set("email", email);
        // finalParams["email"] = email;
      }
    } else {
      finalParams = finalParams.set("code", code).set("type", type);
      // finalParams = { code, type };
    }
    if (orderlink) {
      finalParams = finalParams.set("orderlink", orderlink);
      // finalParams["orderlink"] = orderlink;
    }
    if (!localStorage.getItem("retailerToken")) {
      let appointmentsList = localStorage.getItem("appointmentsList")
        ? JSON.parse(localStorage.getItem("appointmentsList"))
        : [];
      appointmentsList = appointmentsList.forEach((eachAppointment) => {
        if (eachAppointment.code && eachAppointment.name) {
          finalParams = finalParams.append(
            "prevAppointments",
            eachAppointment.code
          );
        }
      });
    } else if (localStorage.getItem("appointmentsList")) {
      localStorage.removeItem("appointmentsList");
    }
    return this.http.get<any>(API_PATH.apis.getvideocalldetails, {
      params: finalParams,
    });
  }
  getCarouselCategories(
    code: string,
    type?: string,
    email?: string,
    OTP?: string,
    spot?: boolean,
    consumerSpot?
  ) {
    if (consumerSpot) {
      return this.http.post<any>(API_PATH.apis.getvideocalldetails, {
        code: code,
        type: "external",
        email: null,
        otp: null,
        spot,
      });
    } else {
      return this.http.post<any>(API_PATH.apis.getvideocalldetails, {
        code: code,
        isCategory: true,
        type,
        email,
        emailOtp: OTP,
        spot,
        skipCategoriesData: true,
      });
    }
  }
  getCarouselOptions(code: string, categoryArray: Array<any>, isConsumerSpot?) {
    if (isConsumerSpot) {
      let httpParams = new HttpParams();
      httpParams = httpParams
        .set("code", code)
        .set("type", "external")
        .set("spot", "true")
        .set("email", "")
        .set("OTP", "");
      return this.http.get<any>(API_PATH.apis.getvideocalldetails, {
        params: httpParams,
      });
    } else {
      return this.http.post<any>(API_PATH.apis.getvideocalldetails, {
        code: code,
        categoryArray: categoryArray,
      });
    }
  }

  addParticipants(
    participant: { email: string; name: string; type: string },
    code: string
  ) {
    return this.http.put<any>(API_PATH.apis.addParticipants, {
      participant,
      code,
    });
  }

  sendEmail(email: string, code: string) {
    return this.http.put<any>(API_PATH.apis.sendOtpEmail, { email, code });
  }
  validateUser(code, isValidate, email?, participantId?, ignoreOtp?, isLogin?) {
    return this.http.put<any>(API_PATH.apis.sendOtpEmail, {
      email,
      participantId,
      code,
      isValidate,
      ignoreOtp,
      isLogin,
    });
  }
  addMultipleParticipants(data) {
    return this.http.put<any>(API_PATH.apis.addParticipants, data);
  }
  getAppointmentGroupData(
    code: string,
    type?: string,
    spot?: boolean,
    email?,
    isDisabled?
  ) {
    let finalParams = {};
    if (spot) {
      if (isDisabled) {
        finalParams = {
          code,
          type,
          email: email,
          OTP: "",
          spot: "true",
          isDisabled: "true",
        };
      } else {
        finalParams = { code, type, email: email, OTP: "", spot: "true" };
      }
    } else {
      finalParams = { code, type };
    }
    return this.http.get<any>(API_PATH.apis.getAppointmentGroupData, {
      params: finalParams,
    });
  }
  updateAppointmentGroupData(data, status, clearAppointmentData?) {
    data.status = status;
    if (status === "Available" || clearAppointmentData) {
      data["appointmentData"] = {};
    }
    return this.http.put<any>(
      API_PATH.apis.updateAppointmentGroupData + data._id,
      data
    );
  }
  getAppointmentUnitSettings(code: string, isRect: boolean) {
    const httpParams = new HttpParams()
      .set("code", code)
      .set("isRect", isRect.toString());
    return this.http.get<any>(API_PATH.apis.getAppointmentSettings, {
      params: httpParams,
    });
  }
}
